import React from 'react';
import Lottie from 'react-lottie';
import * as maniAnimation from '../../assets/animations/main.json';

/**
 * Reusable widget block showing the animated sync illustration and platform logos.
 * Based on the block used on the HappyPOS page.
 */
const RealtimeSyncWidget = ({
  title = '*Valós idejű adatszinkron',
  description = 'Rendszereink a felhőnek köszönhetően folyamatosan, valós időben szinkronizálnak, így akár azt is láthatja, ha kollégája éppen másik rendelést szolgál ki',
  showLogos = true,
}) => {
  return (
    <div className="eduvibe-sidebar" style={{ marginTop: -100 }}>
      <div className="eduvibe-widget eduvibe-widget-details mt--60">
        <h5 className="title text-center">{title}</h5>
        <div className="widget-content">
          <Lottie
            options={{
              loop: true,
              autoplay: true,
              animationData: maniAnimation,
              rendererSettings: { preserveAspectRatio: 'xMidYMid cover' },
            }}
            width={"300px"}
            height={"300px"}
          />
          {description && (
            <p style={{ textAlign: 'justify', marginBottom: -20 }}>{description}</p>
          )}
        </div>
      </div>

      {showLogos && (
        <div className="event-widget event-widget-details mt--40">
          <h5 className="title text-center">Bármely rendszeren*</h5>
          <div
            className="row justify-content-center align-items-center"
            style={{ margin: '0 auto', flexWrap: 'nowrap' }}
          >
            <div className="col widget-content">
              <img
                style={{ height: '6rem', aspectRatio: '1 / 1', objectFit: 'contain' }}
                src="https://happy-releases.fra1.cdn.digitaloceanspaces.com/Uploads/Images/Windows_logo.svg.png"
                alt="Windows"
              />
            </div>
            <div className="col widget-content">
              <img
                style={{ height: '6rem', aspectRatio: '1 / 1', objectFit: 'contain' }}
                src="https://happy-releases.fra1.cdn.digitaloceanspaces.com/Uploads/Images/Apple_logo_black.svg.png"
                alt="Apple"
              />
            </div>
            <div className="col widget-content">
              <img
                style={{ height: '6rem', aspectRatio: '1 / 1', objectFit: 'contain' }}
                src="https://happy-releases.fra1.cdn.digitaloceanspaces.com/Uploads/Images/Android_robot.svg.webp"
                alt="Android"
              />
            </div>
            <div className="col widget-content">
              <img
                style={{ height: '7rem', aspectRatio: '1 / 1', objectFit: 'contain' }}
                src="https://happy-releases.fra1.cdn.digitaloceanspaces.com/Uploads/Images/linux.png"
                alt="Linux"
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default RealtimeSyncWidget;
